//import this from firebase SDK
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// const firebaseConfig = {
//   apiKey: "AIzaSyDARn6xAeS-YvPlEsCzZvw53b5mC9CvdtE",
//   authDomain: "druyp-414204.firebaseapp.com",
//   projectId: "druyp-414204",
//   storageBucket: "druyp-414204.appspot.com",
//   messagingSenderId: "732213545842",
//   appId: "1:732213545842:web:dd94536ef3becac5efebeb",
//   measurementId: "G-F34GFPF2SE"
// };
const firebaseConfig = {
apiKey: "AIzaSyA2AOHTEAAGxUMcaseY_Ox9poU20S7ADRY",
authDomain: "druyp-cefa7.firebaseapp.com",
projectId: "druyp-cefa7",
storageBucket: "druyp-cefa7.firebasestorage.app",
messagingSenderId: "713926714627",
appId: "1:713926714627:web:663b9765fc39c2e4433536",
measurementId: "G-SR2NVTY52G"
};
const app = initializeApp(firebaseConfig);
export const auth=getAuth(app)
export default app
